import {TravelQuotation} from "../../../../model/quotation";
import {showOrNotTechnicalWorkPage} from "../../../MessagePage";
import {calculate, Response} from "../../../../api/quotationApiClient";
import {TravelQuotationPackage} from "../../../../model/quoationPackage";
import {strings} from "../../../../strings/strings";
import {useContext} from "react";
import {ProcessingContext} from "../../../../contexts/ProcessingContext";
import {TravelStepContext} from "../../../../contexts/TravelStepContext";
import {ITravelQuotationContext, TravelQuotationContext} from "../../../../contexts/TravelQuotationContext";
import * as _ from 'lodash';
import {ProductType} from "../../../../api/model/common";

export const useTravelTariffication = (currentStepCode, setTextErrorMessageDialog, setTextDetailErrorMessageDialog, setOpenErrorMessageDialog) => {
    const {quotation, setQuotation, packages, setPackages, tariffied, setTariffied} = useContext<ITravelQuotationContext>(TravelQuotationContext);
    const {nextStepListener} = useContext(TravelStepContext);
    const {setProcessingOpen} = useContext(ProcessingContext);

    const onFormSubmit = (submittedQuotation: TravelQuotation) => {
        if (showOrNotTechnicalWorkPage()) return;
        setProcessingOpen(true);
        const updatedQuotation = _.cloneDeep(submittedQuotation)
        updatedQuotation.travelWebContract.travelPackage = 'OPTIMAL'
        setQuotation(updatedQuotation);

        calculate(updatedQuotation, ProductType.TRAVEL).then((response: Response) => {
            if (response.success) {
                const travelPackages: TravelQuotationPackage[] = response.data as TravelQuotationPackage[];

                setPackages(travelPackages);
                setTariffied(true);
                setProcessingOpen(false);
            } else {
                setProcessingOpen(false);
                setTextErrorMessageDialog(strings.tarifficationErrorMessage);
                setTextDetailErrorMessageDialog(response.errorResponse.text + "; " + response.errorResponse.detailText);
                setOpenErrorMessageDialog(true);
            }
            window.scrollTo(0, 0);
        });
    };

    const onPackageSelect = () => {

        nextStepListener(quotation);
    };

    const onSumInsuredSelect = (submittedQuotation: TravelQuotation) => {
        if (showOrNotTechnicalWorkPage()) return;
        setProcessingOpen(true);
        setQuotation(submittedQuotation);

        calculate(submittedQuotation, ProductType.TRAVEL).then((response: Response) => {
            if (response.success) {
                const travelPackages: TravelQuotationPackage[] = response.data as TravelQuotationPackage[];
                setPackages(travelPackages);
                const pkg = travelPackages.find(pack => pack.travelPackage === quotation.travelWebContract.travelPackage)
                const updatedQuotation = {
                    ...quotation,
                    totalPremium: pkg.premium,
                    travelWebContract: {
                        ...quotation.travelWebContract,
                        sumInsured: pkg.sumInsured,
                        premium: pkg.premium
                    }
                }
                setQuotation(updatedQuotation)
                setTariffied(true);
                setProcessingOpen(false);
            } else {
                setProcessingOpen(false);
                setTextErrorMessageDialog(strings.tarifficationErrorMessage);
                setTextDetailErrorMessageDialog(response.errorResponse.text + "; " + response.errorResponse.detailText);
                setOpenErrorMessageDialog(true);
            }
            window.scrollTo(0, 0);
        });
    };

    const onRecalculate = () => {
        setTariffied(false);
    };

    return {
        tariffied,
        setTextErrorMessageDialog,
        setTextDetailErrorMessageDialog,
        setOpenErrorMessageDialog,
        packages,
        onPackageSelect,
        onSumInsuredSelect,
        onRecalculate,
        onFormSubmit
    };
};